export default {
  CHANGE_NIGHTS: 'priceCalendar/CHANGE_NIGHTS',
  CHANGE_DESTINATION_COUNTRY: 'priceCalendar/CHANGE_DESTINATION_COUNTRY',
  CHANGE_DEPARTURE_CITY: 'priceCalendar/CHANGE_DEPARTURE_CITY',

  GET_PRICES_BY_DAYS: 'priceCalendar/GET_PRICES_BY_DAYS',
  GET_PRICES_BY_DAYS_SUCCESS: 'priceCalendar/GET_PRICES_BY_DAYS_SUCCESS',
  GET_PRICES_BY_DAYS_FAIL: 'priceCalendar/GET_PRICES_BY_DAYS_FAIL',
};
